let que = [
  [
    0, 0, 4, 3, 0, 0, 2, 0, 9, 0, 0, 5, 0, 0, 9, 0, 0, 1, 0, 7, 0, 0, 6, 0, 0,
    4, 3, 0, 0, 6, 0, 0, 2, 0, 8, 7, 1, 9, 0, 0, 0, 7, 4, 0, 0, 0, 5, 0, 0, 8,
    3, 0, 0, 0, 6, 0, 0, 0, 0, 0, 1, 0, 5, 0, 0, 3, 5, 0, 8, 6, 9, 0, 0, 4, 2,
    9, 1, 0, 3, 0, 0,
  ],

  [
    0, 4, 0, 1, 0, 0, 0, 5, 0, 1, 0, 7, 0, 0, 3, 9, 6, 0, 5, 2, 0, 0, 0, 8, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 7, 0, 0, 0, 9, 0, 6, 8, 0, 0, 8, 0, 3, 0, 5,
    0, 6, 2, 0, 0, 9, 0, 0, 6, 0, 5, 4, 3, 6, 0, 0, 0, 8, 0, 7, 0, 0, 2, 5, 0,
    0, 9, 7, 1, 0, 0,
  ],

  [
    6, 0, 0, 1, 2, 0, 3, 8, 4, 0, 0, 8, 4, 5, 9, 0, 7, 2, 0, 0, 0, 0, 0, 6, 0,
    0, 5, 0, 0, 0, 2, 6, 4, 0, 3, 0, 0, 7, 0, 0, 8, 0, 0, 0, 6, 9, 4, 0, 0, 0,
    3, 0, 0, 0, 3, 1, 0, 0, 0, 0, 0, 5, 0, 0, 8, 9, 7, 0, 0, 0, 0, 0, 5, 0, 2,
    0, 0, 0, 1, 9, 0,
  ],
];

const ans = [
  [
    8, 6, 4, 3, 7, 1, 2, 5, 9, 3, 2, 5, 8, 4, 9, 7, 6, 1, 9, 7, 1, 2, 6, 5, 8,
    4, 3, 4, 3, 6, 1, 9, 2, 5, 8, 7, 1, 9, 8, 6, 5, 7, 4, 3, 2, 2, 5, 7, 4, 8,
    3, 9, 1, 6, 6, 8, 9, 7, 3, 4, 1, 2, 5, 7, 1, 3, 5, 2, 8, 6, 9, 4, 5, 4, 2,
    9, 1, 6, 3, 7, 8,
  ],

  [
    3, 4, 6, 1, 7, 9, 2, 5, 8, 1, 8, 7, 5, 2, 3, 9, 6, 4, 5, 2, 9, 6, 4, 8, 3,
    7, 1, 9, 6, 5, 8, 3, 2, 4, 1, 7, 4, 7, 2, 9, 1, 6, 8, 3, 5, 8, 1, 3, 7, 5,
    4, 6, 2, 9, 7, 9, 8, 2, 6, 1, 5, 4, 3, 6, 3, 1, 4, 8, 5, 7, 9, 2, 2, 5, 4,
    3, 9, 7, 1, 8, 6,
  ],

  [
    6, 9, 5, 1, 2, 7, 3, 8, 4, 1, 3, 8, 4, 5, 9, 6, 7, 2, 7, 2, 4, 8, 3, 6, 9,
    1, 5, 8, 5, 1, 2, 6, 4, 7, 3, 9, 2, 7, 3, 9, 8, 1, 5, 4, 6, 9, 4, 6, 5, 7,
    3, 8, 2, 1, 3, 1, 7, 6, 9, 2, 4, 5, 8, 4, 8, 9, 7, 1, 5, 2, 6, 3, 5, 6, 2,
    3, 4, 8, 1, 9, 7,
  ],
];

let len = que.length;
// console.log("len=",len);
export function getQueAns() {
  let randomIndex = Math.floor(Math.random() * len);
  // console.log( ( que[randomIndex].length ) );
  return [que[randomIndex], ans[randomIndex]];
}
